<!-- Modal Wrapper -->
<div *ngIf="showModal" class="modal-backdrop-wrapper">
  <!-- Backdrop -->
  <div class="modal-backdrop fade show" (click)="close()"></div>

  <!-- Modal -->
  <div class="custom-modal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header">
          <h5 class="modal-title m-0">Vehicle Details</h5>
          <button type="button" class="close" (click)="close()">
            <span>&times;</span>
          </button>
        </div>

        <!-- Scrollable Body -->
        <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
          <!-- Vehicle Image -->
          <div class="text-center mb-3">
            <img
              [src]="vehicleForm.value.image || 'assets/no-image.png'"
              alt="Vehicle Image"
              class="img-fluid rounded"
              style="max-height: 200px"
            />
          </div>

          <!-- Vehicle Details Table -->
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th style="width: 40%">Truck Type</th>
                <td>{{ vehicleForm.value.truckType }}</td>
              </tr>
              <tr>
                <th>Vehicle Length</th>
                <td>{{ vehicleForm.value.vehicleLength }} ft</td>
              </tr>
              <tr>
                <th>Vehicle Breadth</th>
                <td>{{ vehicleForm.value.vehicleBreadth }} ft</td>
              </tr>
              <tr>
                <th>Vehicle Height</th>
                <td>{{ vehicleForm.value.vehicleHeight }} ft</td>
              </tr>
              <tr>
                <th>Truck Tyres</th>
                <td>{{ vehicleForm.value.truckTyres }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Truck Tons Table -->
          <h6 class="m-2">Available Truck Tons</h6>
          <table class="table table-striped table-sm">
            <thead class="thead-light">
              <tr>
                <th>Min Capacity (tons)</th>
                <th>Max Capacity (tons)</th>
                <th style="width: 80px">Actions</th>
              </tr>
            </thead>
            <tbody>
              <!-- Editable Existing Rows -->
              <tr *ngFor="let ton of availableTons; let i = index">
                <td>
                  <input
                    type="number"
                    [(ngModel)]="ton.minCapacity"
                    class="form-control form-control-sm"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    [(ngModel)]="ton.maxCapacity"
                    class="form-control form-control-sm"
                  />
                </td>

                <td>
                  <!-- Edit button -->
                  <button
                    class="btn btn-light btn-sm mr-1"
                    (click)="editTon(ton)"
                    title="Edit Ton"
                  >
                    <i class="fa fa-edit"></i>
                  </button>

                  <!-- Delete button -->
                  <button
                    class="btn btn-danger btn-sm"
                    (click)="deleteTon(ton._id)"
                    title="Delete Ton"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Add New Row -->
          <div class="d-flex mb-2">
            <input
              type="number"
              [(ngModel)]="newMinCapacity"
              placeholder="Min Capacity"
              class="form-control form-control-sm mr-2"
            />
            <input
              type="number"
              [(ngModel)]="newMaxCapacity"
              placeholder="Max Capacity"
              class="form-control form-control-sm mr-2"
            />
            <button class="btn btn-success btn-sm" (click)="addTon()">
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
